module.exports = __webpack_public_path__ + "static/img/realease-04.82467d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/realease-04.png
// module id = 144
// module chunks = 0